import DarkModeIcon from '@mui/icons-material/DarkMode';
import { Menu, MenuItem, Switch } from '@mui/material';
import React, { CSSProperties, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAppContext } from '../contexts/AppContext';
import { isProd } from '../helper/helper';
import { ProfileModel } from '../models/person/ProfileModel';
import { ProviderModal, ProviderState } from '../pages/contracts/ProviderModal';
import { ReactComponent as ChevronIcon } from "../rsc/chevron.svg";
import { colorDark, colorPrimaryStatic } from '../rsc/colors/colors';
import { ReactComponent as AdminIcon } from "../rsc/ic_admin.svg";
import { ReactComponent as LogoutIcon } from "../rsc/ic_logout.svg";
import { ReactComponent as ProfileIcon } from "../rsc/ic_profile.svg";
import { AdminInfo, MenuState } from '../stores/store';
import Avatar from "./Avatar";


type ProfileActionProps = {
    style: CSSProperties,
    logOut: () => void,
    goToProfile: () => void,
    goToAdminPage: () => void,
    isAdmin: AdminInfo,
    refForMenu: HTMLDivElement
}

export const ProfileActions: React.FC<ProfileActionProps> = ({ style = {}, logOut, goToProfile, goToAdminPage, isAdmin, refForMenu }: ProfileActionProps) => {

    const menuState: MenuState = useSelector((state: any) => state.menu.value)

    const { theme, setTheme } = useAppContext()

    const user: ProfileModel | null = useSelector((state: any) => ProfileModel.fromJson(state.userProfile.value))
    const [providers, setProviders] = useState<ProviderState>(null)

    const displayProvider = () => {
        return (
            <ProviderModal onClose={() => setProviders(null)} providers={providers} />
        )
    }

    const { t } = useTranslation();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const onThemChange = () => {
        const newValue = theme === 'dark' ? 'light' : 'dark'
        setTheme(newValue)
    }

    return (
        <div style={style}>
            {
                providers ? displayProvider() : <></>
            }
            <div onClick={(e) => handleClick(e)} style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Avatar style={{ width: "40px", height: "40px" }} uri={user.avatarUri()} firstname={user.person.firstname} lastname={user.person.lastname} />
                {!menuState.isMobile && <p style={{ display: "inline-block", marginLeft: "10px", fontSize: "16px" }}>{user.person.firstname} {user.person.lastname}</p>}
                <ChevronIcon fill='white' style={{ marginLeft: "10px", verticalAlign: "middle" }} />
            </div>
            {
                refForMenu?.offsetWidth ?
                    // <MenuSelector />
                    <Menu
                        disableScrollLock={true}
                        marginThreshold={null}
                        MenuListProps={{ sx: { py: 0 } }} //Used to remove some padding
                        style={{ margin: "0px", padding: "0px" }}
                        PaperProps={{ sx: { width: 150, borderRadius: 2 } }}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}>
                        <MenuItem style={{
                            height: "50px",
                            width: refForMenu.offsetWidth,
                            maxWidth: refForMenu.offsetWidth,
                            padding: "0px 10px"
                        }} onClick={() => { handleClose(); goToProfile() }}>
                            <div className='pempem-flex-row'>
                                <ProfileIcon stroke={colorDark()} style={{ width: "20px", height: "auto", marginRight: "10px" }} />
                                <span style={{ marginLeft: "5px", textAlign: "left", marginTop: "0px", marginBottom: "0px", flex: "2" }}>{t('my_profile')}</span>
                            </div>
                        </MenuItem>
                        <MenuItem style={{
                            height: "50px",
                            display: isAdmin.dashboardEnable ? "flex" : "none",
                            width: refForMenu.offsetWidth,
                            maxWidth: refForMenu.offsetWidth,
                            padding: "0px 10px"
                        }} onClick={() => { handleClose(); goToAdminPage() }}>
                            <div className='pempem-flex-row'>
                                <AdminIcon fill={colorDark()} style={{ width: "20px", height: "auto", marginRight: "10px" }} />
                                <span style={{ marginLeft: "5px", textAlign: "left", marginTop: "0px", marginBottom: "0px", flex: "2" }}>{t('admin')}</span>
                            </div>
                        </MenuItem>
                        <MenuItem style={{
                            height: "50px",
                            width: refForMenu.offsetWidth,
                            maxWidth: refForMenu.offsetWidth,
                            padding: "0px 10px"
                        }}>
                            <div className='pempem-flex-row-center'>
                                <DarkModeIcon fill={colorPrimaryStatic()} style={{ width: "20px", height: "auto", marginRight: "10px" }} />
                                <Switch onChange={onThemChange} checked={theme === "dark"} style={{ marginLeft: "5px", textAlign: "left", marginTop: "0px", marginBottom: "0px", flex: "2" }} />
                            </div>
                        </MenuItem>
                        <MenuItem style={{
                            height: "50px",
                            width: refForMenu.offsetWidth,
                            maxWidth: refForMenu.offsetWidth,
                            padding: "0px 10px"
                        }} onClick={() => { handleClose(); logOut() }}>
                            <div className='pempem-flex-row'>
                                <LogoutIcon fill={colorDark()} style={{ width: "20px", height: "auto", marginRight: "10px" }} />
                                <span style={{ marginLeft: "5px", textAlign: "left", marginTop: "0px", marginBottom: "0px", flex: "2" }}>{t('log_out')}</span>
                            </div>
                        </MenuItem>
                    </Menu>
                    : <></>
            }
        </div>
    )
}

export default ProfileActions